export default __webpack_public_path__ + "static/media/HowToHighlight.3905ca98.webm";